import { useV2GetPsaCompaniesQuery } from "@generated";
import { Opt } from "../../types/PsaProject";

const toOpts = (data?: { id?: any; name?: string }[]): Opt[] =>
  (data ?? []).map((r) => ({ value: String(r.id), label: r.name ?? "" }));

export const usePsaCompanies = (integrationId: string, search: string) => {
  const { data, isFetching } = useV2GetPsaCompaniesQuery(
    { id: integrationId, startsWith: search },
    { skip: search.trim().length < 3 }
  );
  return { companies: toOpts(data?.data), isFetching };
};
